let startLoading = () => {};
let stopLoading = () => {};

export const setProgressLoadingFunctions = (startFn, stopFn) => {
  startLoading = startFn;
  stopLoading = stopFn;
};

export const showProgressLoader = () => startLoading();
export const hideProgressLoader = () => stopLoading();
